import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { KioskState } from ".";
import { login } from "../actions/configActions";
import { logout } from "../actions/userActions";
import FourOFour from "../containers/FourOFour";
import ConnectionStatus from "./ConnectionStatus";
import parseQueryParams from "../modules/parse-query-params";
import { inIframe } from "../misc/inIframe";

import Init from "./callStates/Init";
import Ready from "./callStates/Ready";
import WrongUnamePwd from "./callStates/WrongUsernamePassword";
import TokenInvalid from "./callStates/TokenInvalid";
import TokenExpired from "./callStates/TokenExpired";
import Calling from "./callStates/Call";
import InCall from "./callStates/InCall";
import InMainCall from "./callStates/InMainCall";
import CallCompleted from "./callStates/CallCompleted";
import RejectedRemote from "./callStates/RejectedRemote";
import TerminatedRemote from "./callStates/TerminatedRemote";
import UnknownNumber from "./callStates/UnknownNumber";

class KioskPage extends React.Component {
  componentDidMount() {
    const token = this.props.router.location.search.substr(1);
    const tokenValue = parseQueryParams(token);

    if (!this.props.user) {
      this.props.login(
        this.props.anonymous_enabled
          ? this.props.anonymous.user
          : tokenValue.username,
        this.props.anonymous_enabled
          ? this.props.anonymous.password
          : tokenValue.password,
        token
      );
    }
  }

  callScreen() {
    if (this.props.kiosk_main_layout) {
      return <InMainCall />;
    }

    return <InCall />;
  }

  render() {
    if (
      !this.props.kiosk ||
      (!this.props.inIframe && inIframe()) ||
      (this.props.forceIframe && !inIframe())
    ) {
      return <FourOFour />;
    }

    const { kioskState } = this.props;

    switch (kioskState) {
      case KioskState.init:
        return <Init />;
      case KioskState.ready:
        return <Ready />;
      case KioskState.wrongUsernamePassword:
        return <WrongUnamePwd />;
      case KioskState.tokenInvalid:
        return <TokenInvalid />;
      case KioskState.tokenExpired:
        return <TokenExpired />;
      case KioskState.acceptedRemote:
        return this.callScreen();
      case KioskState.calling:
        return <Calling />;
      case KioskState.rejectedRemote:
        return <RejectedRemote />;
      case KioskState.terminatedRemote:
        return <TerminatedRemote />;
      case KioskState.unregisteredNumber:
      case KioskState.unknownNumber:
        this.props.logout();
        return <UnknownNumber />;
      case KioskState.terminatedLocal:
      case KioskState.callCompleted:
        this.props.logout();
        return <CallCompleted />;
      default:
        break;
    }
    return <ConnectionStatus status={kioskState} />;
  }
}

KioskPage.propTypes = {
  kioskState: PropTypes.number.isRequired,
  to: PropTypes.string,
};

const dispatchToProps = dispatch => {
  return {
    login: (username, password, token) => {
      return dispatch(login(username, password, token));
    },
    logout: () => {
      return dispatch(logout());
    },
  };
};

const stateToProps = (state, router) => {
  return {
    anonymous_enabled: state.config.mode.anonymous_enabled,
    anonymous_autologin: state.config.mode.anonymous_autologin,
    user: state.config.user,
    anonymous: state.config.anonymous,
    kiosk: state.config.mode.kiosk,
    kioskState: state.kiosk.state,
    kiosk_main_layout: state.config.mode.kiosk_main_layout,
    router: router,
    inIframe: state.config.mode.inIframe,
    forceIframe: state.config.mode.forceIframe,
  };
};

export default connect(stateToProps, dispatchToProps)(KioskPage);



// WEBPACK FOOTER //
// ./src/kiosk/KioskPage.jsx